import { useTranslation } from 'react-i18n-lite'

import ActivityValue from './ActivityValue'
import { formatFileSize } from 'modules/shared/utils/formatFileSize'
import { StatusClass } from 'types/shared'
import { useDocumentURL } from 'modules/document/hooks'

interface ActivityDocumentPhotoProps {
  values: string
  statusClass?: StatusClass
}

const ActivityDocumentPhoto = ({
  values,
  statusClass
}: ActivityDocumentPhotoProps) => {
  const { t } = useTranslation()

  const obj = JSON.parse(values)

  const { documentURL } = useDocumentURL({ s3PrivateURL: obj?.url })

  return (
    <>
      <ActivityValue
        label={t('activity-document-photo.labels.des')}
        value={obj.des}
        statusClass={statusClass}
      />
      <ActivityValue
        label={t('activity-document-photo.labels.uuid-foto')}
        value={obj.uuid}
        statusClass={statusClass}
        placeholder={t('activity-document-photo.placeholders.uuid-foto')}
      />
      <ActivityValue
        label={t('activity-document-photo.labels.status')}
        value={obj.statusDes}
        statusClass={statusClass}
        placeholder={t('activity-document-photo.placeholders.status')}
      />
      <div className='row'>
        <div className='col-6'>
          <ActivityValue
            label={t('activity-document-photo.labels.content-type')}
            value={obj.contentType}
            statusClass={statusClass}
            placeholder={t('activity-document-photo.placeholders.content-type')}
          />
        </div>
        <div className='col-6'>
          <ActivityValue
            label={t('activity-document-photo.labels.size')}
            value={obj.size ? formatFileSize(Number(obj.size)) : ''}
            statusClass={statusClass}
            placeholder={t('activity-document-photo.placeholders.size')}
          />
        </div>
      </div>
      <div className='w-100 d-flex justify-content-center align-items-center'>
        {documentURL ? (
          <img
            src={documentURL}
            className='img-fluid rounded'
            alt={`${obj?.des || 'Photo'}`}
          />
        ) : (
          <div className='w-100 webcam-no-image rounded'>
            {t('activity-document-photo.no-image')}
          </div>
        )}
      </div>
    </>
  )
}

export default ActivityDocumentPhoto
